/**
 * MODAL: CREATE ASSOCIATION
 * Modal pour créer une nouvelle association
 */

import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import type { CreateAssociationInput } from '../../schemas/association';
import { createAssociationSchema } from '../../schemas/association';
import { Form, FormInput } from '../ui';
import { Modal, ModalFooter } from '../ui/modal';

interface CreateAssociationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: CreateAssociationInput) => Promise<void>;
}

export function CreateAssociationModal({ isOpen, onClose, onSubmit }: CreateAssociationModalProps) {
  const form = useForm<CreateAssociationInput>({
    resolver: zodResolver(createAssociationSchema),
  });

  const handleClose = () => {
    form.reset();
    onClose();
  };

  const handleFormSubmit = async (data: CreateAssociationInput) => {
    await onSubmit(data);
    handleClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Créer une association"
      size="md"
      footer={
        <ModalFooter
          onCancel={handleClose}
          submitLabel="Créer"
          isSubmitting={form.formState.isSubmitting}
          formId="create-association-form"
        />
      }
    >
      <Form {...form}>
        <form id="create-association-form" onSubmit={form.handleSubmit(handleFormSubmit)}>
          <div className="flex flex-col gap-4">
            <FormInput
              control={form.control}
              name="name"
              label="Nom de l'association"
              required
              placeholder="Ex: Secours Populaire Français"
            />
          </div>
        </form>
      </Form>
    </Modal>
  );
}
